import { GatsbyImage, IGatsbyImageData } from 'gatsby-plugin-image';
import React from 'react';
import Heading from 'app_previous/elements/typography/heading';
import Paragraph from 'app_previous/elements/typography/paragraph';
import useBaseLink from 'src/hooks/useBaseLink';
import { SlideContainer, SlideImageContainer, SlideTextBlock } from './Slide.styles';
import { palette } from 'app_previous/styles/colors';

export interface SlideProps {
  title: string;
  description?: string;
  image: IGatsbyImageData;
  url: string;
  isInternal?: boolean;
  textColor?: string;
}

const Slide = (props: SlideProps): JSX.Element => {
  const linkProps = useBaseLink(props.url);

  return (
    <SlideContainer
      className='article-slide-container'
      {...linkProps}
    >
      <SlideImageContainer>
        <GatsbyImage
          image={props.image}
          alt={props.title}
        />
      </SlideImageContainer>
      <SlideTextBlock>
        <Heading
          text={props.title}
          standardSize='2.125'
          align='left'
          className='article-slide-title'
          color={props.textColor || palette.greyText}
          weight={600}
        />
        <Paragraph
          text={props.description}
          align='left'
          weight={'light'}
          standardSize='1.5'
          color={props.textColor || palette.greyText}
        />
      </SlideTextBlock>
    </SlideContainer>
  );
};

export default Slide;
